export default [
  {
    heading: 'Models',
    data: ['12', '8']
  },
  {
    heading: 'Input Range',
    data: ['750,000 - 6,000,000 Btu/hr', '999,000 - 6,000,000 Btu/hr']
  },
  {
    heading: 'Outdoor Availability',
    data: ['Yes', 'Coming Soon']
  },
  {
    heading: 'RealTime O₂ Feedback™',
    data: ['Optional', 'Standard']
  },
  {
    heading: 'RealTime O₂ Trim™',
    data: ['X', 'Standard']
  },
  {
    heading: 'SMART TOUCH™ Display',
    data: ['8” Resistive Touch Screen', '10” Capacitive Touch Screen']
  },
  {
    heading: 'Maximum Direct Vent Length',
    data: ['100 ft', '150 ft']
  },
  {
    heading: 'LED Identification Lights on Control Boards',
    data: ['X', 'Standard']
  },
  {
    heading: 'CON·X·US® Remote Connect',
    data: ['Standard', 'Standard']
  },
  {
    heading: 'Minimum Turndown',
    data: ['10:1', '20:1']
  }
];
